interface ToolResultState {
  running: boolean;
  outcome: string | null;
}

export type ToolOutcome =
  | { kind: "awaiting" }
  | { kind: "pending" }
  | { kind: "unknown" }
  | { kind: "word"; word: string };

export const OUTCOME_AWAITING: ToolOutcome = { kind: "awaiting" };
export const OUTCOME_PENDING: ToolOutcome = { kind: "pending" };
const OUTCOME_UNKNOWN: ToolOutcome = { kind: "unknown" };

export function toolOutcome(tool: ToolResultState, awaitingApproval = false): ToolOutcome {
  if (tool.running) return awaitingApproval ? OUTCOME_AWAITING : OUTCOME_PENDING;
  const word = (tool.outcome ?? "").trim();
  return word === "" ? OUTCOME_UNKNOWN : { kind: "word", word };
}

export function isUnresolved(tool: ToolResultState): boolean {
  return toolOutcome(tool).kind === "unknown";
}

export function hasResult(tool: ToolResultState): boolean {
  return toolOutcome(tool).kind === "word";
}

export function wasOutcomeReadBack(
  outcome: ToolOutcome,
  toolCallId: string,
  readBack: readonly string[] | null | undefined,
): boolean {
  if (outcome.kind !== "word") return false;
  return readBack?.includes(toolCallId) ?? false;
}

export function outcomeKey(outcome: ToolOutcome): string {
  return outcome.kind === "word" ? `word:${outcome.word}` : outcome.kind;
}

const ELAPSED_VISIBLE_AFTER_MS = 10_000;

export function elapsedLabel(
  outcome: ToolOutcome,
  startedAt: number | null | undefined,
  now: number,
): string | null {
  if (outcome.kind !== "pending") return null;
  if (typeof startedAt !== "number") return null;
  const ms = now - startedAt;
  if (!(ms >= ELAPSED_VISIBLE_AFTER_MS)) return null;
  const total = Math.floor(ms / 1000);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}
